import { render, staticRenderFns } from "./AccProductCreateForm.vue?vue&type=template&id=fd518f5c"
import script from "./AccProductCreateForm.vue?vue&type=script&lang=js"
export * from "./AccProductCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports